export default {
	APIKey: "https://4d5a821c73024ee797142c72c0bba424@o148567.ingest.us.sentry.io/4505092301258752",
};
